import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'

interface SidebarState {
  open: boolean
}

const initialState: SidebarState = {
  open: false,
}

export const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setSidebarOpen: (state, action: PayloadAction<boolean>) => ({
      open: action.payload,
    }),
    toggleSidebarState: state => ({
      open: !state.open,
    }),
  },
})

export const { setSidebarOpen, toggleSidebarState } = sidebarSlice.actions

export const getSidebarState = (state: RootState) => state.sidebar.open

export default sidebarSlice.reducer
